/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctorMatchingControllerFindMatchingDoctor } from '../fn/doctor-matching/doctor-matching-controller-find-matching-doctor';
import { DoctorMatchingControllerFindMatchingDoctor$Params } from '../fn/doctor-matching/doctor-matching-controller-find-matching-doctor';
import { FilterResponseMatchingDoctorDto } from '../models/filter-response-matching-doctor-dto';

@Injectable({ providedIn: 'root' })
export class DoctorMatchingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorMatchingControllerFindMatchingDoctor()` */
  static readonly DoctorMatchingControllerFindMatchingDoctorPath = '/thalea-match/doctor-matching/filter';

  /**
   * Find doctors matching the specified criteria.
   *
   * Searches for doctors based on various criteria such as specialization, age, experience, gender, and formality level. Returns a doctor that best matches the criteria. If excludeDoctorId is provided, ensures the returned doctor is different from the specified ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorMatchingControllerFindMatchingDoctor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorMatchingControllerFindMatchingDoctor$Response(params: DoctorMatchingControllerFindMatchingDoctor$Params, context?: HttpContext): Observable<StrictHttpResponse<FilterResponseMatchingDoctorDto>> {
    return doctorMatchingControllerFindMatchingDoctor(this.http, this.rootUrl, params, context);
  }

  /**
   * Find doctors matching the specified criteria.
   *
   * Searches for doctors based on various criteria such as specialization, age, experience, gender, and formality level. Returns a doctor that best matches the criteria. If excludeDoctorId is provided, ensures the returned doctor is different from the specified ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorMatchingControllerFindMatchingDoctor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorMatchingControllerFindMatchingDoctor(params: DoctorMatchingControllerFindMatchingDoctor$Params, context?: HttpContext): Observable<FilterResponseMatchingDoctorDto> {
    return this.doctorMatchingControllerFindMatchingDoctor$Response(params, context).pipe(
      map((r: StrictHttpResponse<FilterResponseMatchingDoctorDto>): FilterResponseMatchingDoctorDto => r.body)
    );
  }

}
